import api from '../api';

export const fetchActivity = (data) => api.post('/core/functions/fetchActivity', data);
